import './Timeline.css';

const steps = [
  'Assessment',
  'Architecture',
  'Migration',
  'Optimization',
  'Monitoring',
];

export default function Timeline() {
  return (
    <div className="timeline-shell" aria-label="Cloud delivery process timeline">
      <div className="timeline-track" />
      <div className="timeline-items">
        {steps.map((step, index) => (
          <div key={step} className="timeline-item">
            <div className="timeline-marker">
              <span>{index + 1}</span>
            </div>
            <div>
              <h4>{step}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
